import { KEYCLOACK_CONFIG } from '@app/_app-config/keycloak-config';
import { APP_CONFIG }       from '@app/_app-config/_app-config_master';

function forceLocalPathOnDisabledKeycloakService( defaultFlag: boolean ): boolean {
	return KEYCLOACK_CONFIG.useKeycloakService ? defaultFlag : true;
}

const baseUrl = APP_CONFIG.baseUrl;

export const API_CONFIG = {
	API_BASE_LOCAL_PATH: 'http://localhost:8000/api/',
	API_BASE_PATH: `${baseUrl}/api/`,
	KEYCLOAK_CHANGE_PASSWORD_PATH: `${baseUrl}/auth/realms/df/account/password`,
	// admin: {
	// 	path: APP_CONFIG.admin.api.path,
	// 	endpoint: APP_CONFIG.admin.api.endpoint,
	// 	useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.admin.api.useLocalPath ),
	// 	useMapping: APP_CONFIG.admin.api.useMapping,
	// 	mappingOutgoingData: APP_CONFIG.admin.api.mappingOutgoingData
	// },
	entities: {
		authentication: {
			path: APP_CONFIG.authentication.api.path,
			endpoint: APP_CONFIG.authentication.api.endpoint,
			useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.authentication.api.useLocalPath ),
			useMapping: APP_CONFIG.authentication.api.useMapping,
			mappingOutgoingData: APP_CONFIG.authentication.api.mappingOutgoingData
		},
		roles: {
			path: APP_CONFIG.roles.api.path,
			endpoint: APP_CONFIG.roles.api.endpoint,
			useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.roles.api.useLocalPath ),
			useMapping: APP_CONFIG.roles.api.useMapping,
			mappingOutgoingData: APP_CONFIG.roles.api.mappingOutgoingData
		},
		tss: {
			path: APP_CONFIG.tss.api.path,
			endpoint: APP_CONFIG.tss.api.endpoint,
			useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.tss.api.useLocalPath ),
			useMapping: APP_CONFIG.tss.api.useMapping,
			mappingOutgoingData: APP_CONFIG.tss.api.mappingOutgoingData
		},
		users: {
			path: APP_CONFIG.users.api.path,
			endpoint: APP_CONFIG.users.api.endpoint,
			useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.users.api.useLocalPath ),
			useMapping: APP_CONFIG.users.api.useMapping,
			mappingOutgoingData: APP_CONFIG.users.api.mappingOutgoingData
		},
		organizations: {
			path: APP_CONFIG.organizations.api.path,
			endpoint: APP_CONFIG.organizations.api.endpoint,
			useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.organizations.api.useLocalPath ),
			useMapping: APP_CONFIG.organizations.api.useMapping,
			mappingOutgoingData: APP_CONFIG.organizations.api.mappingOutgoingData
		},
		businessPremises: {
			path: APP_CONFIG.businesspremises.api.path,
			endpoint: APP_CONFIG.businesspremises.api.endpoint,
			useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.businesspremises.api.useLocalPath ),
			useMapping: APP_CONFIG.businesspremises.api.useMapping,
			mappingOutgoingData: APP_CONFIG.businesspremises.api.mappingOutgoingData
		},
		ers: {
			path: APP_CONFIG.ers.api.path,
			endpoint: APP_CONFIG.ers.api.endpoint,
			useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.ers.api.useLocalPath ),
			useMapping: APP_CONFIG.ers.api.useMapping,
			mappingOutgoingData: APP_CONFIG.ers.api.mappingOutgoingData
		},
		import: {
			path: APP_CONFIG.import.api.path,
			endpoint: APP_CONFIG.import.api.endpoint,
			useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.import.api.useLocalPath ),
			useMapping: APP_CONFIG.import.api.useMapping,
			mappingOutgoingData: APP_CONFIG.import.api.mappingOutgoingData
		},
		encryptionKeys: {
			path: APP_CONFIG.encryptionKeys.api.path,
			endpoint: APP_CONFIG.encryptionKeys.api.endpoint,
			useLocalPath: forceLocalPathOnDisabledKeycloakService( APP_CONFIG.encryptionKeys.api.useLocalPath ),
			useMapping: APP_CONFIG.encryptionKeys.api.useMapping,
			mappingOutgoingData: APP_CONFIG.encryptionKeys.api.mappingOutgoingData
		}
	}
};
